"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormBottomBar;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _styles = require("@mui/styles");
var _useDeviceInfo2 = _interopRequireDefault(require("../../utils/useDeviceInfo"));
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    bottomBar: {
      background: "linear-gradient(to right, ".concat(theme.palette.TwClrBaseGray025, "00,") + "".concat(theme.palette.TwClrBaseGray025, "80, ").concat(theme.palette.TwClrBaseGray025, "80,") + "".concat(theme.palette.TwClrBaseGray025, "00)"),
      backdropFilter: 'blur(16px)',
      borderTop: '1px solid',
      borderImage: "linear-gradient(to right, ".concat(theme.palette.TwClrBaseGray300, "00,") + "".concat(theme.palette.TwClrBaseGray300, "FF, ").concat(theme.palette.TwClrBaseGray300, "FF,") + "".concat(theme.palette.TwClrBaseGray300, "FF, ").concat(theme.palette.TwClrBaseGray300, "00) 1"),
      boxShadow: 'none',
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: function flexDirection(props) {
        return props.isMobile ? 'column-reverse' : 'row';
      },
      padding: function padding(props) {
        return props.isDesktop ? '16px 24px' : "16px 24px ".concat(theme.spacing(5));
      },
      width: function width(props) {
        return props.isDesktop ? 'calc(100% - 200px)' : '100%';
      },
      zIndex: 1000
    },
    button: {
      marginTop: function marginTop(props) {
        return props.isMobile ? theme.spacing(1) : 'auto';
      }
    },
    rightButtons: {
      marginTop: function marginTop(props) {
        return props.isMobile ? theme.spacing(1) : 'auto';
      },
      marginRight: theme.spacing(1)
    },
    rightButtonGroup: {
      display: 'flex',
      flexDirection: function flexDirection(props) {
        return props.isMobile ? 'column-reverse' : 'row';
      }
    }
  };
});
function FormBottomBar(_ref) {
  var cancelID = _ref.cancelID,
    saveID = _ref.saveID,
    onCancel = _ref.onCancel,
    cancelButtonText = _ref.cancelButtonText,
    saveButtonText = _ref.saveButtonText,
    saveDisabled = _ref.saveDisabled,
    onSave = _ref.onSave,
    additionalRightButtons = _ref.additionalRightButtons;
  var _useDeviceInfo = (0, _useDeviceInfo2.default)(),
    isMobile = _useDeviceInfo.isMobile,
    isDesktop = _useDeviceInfo.isDesktop;
  var classes = useStyles({
    isMobile: isMobile,
    isDesktop: isDesktop
  });
  return /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    position: "fixed",
    color: "primary",
    style: {
      top: 'auto',
      bottom: 0,
      right: 'auto',
      left: isDesktop ? 'auto' : 0
    },
    className: classes.bottomBar
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: cancelID || 'cancelBottomBar',
    size: "medium",
    label: cancelButtonText,
    onClick: onCancel,
    priority: "secondary",
    type: "passive",
    className: classes.button
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rightButtonGroup
  }, additionalRightButtons && additionalRightButtons.map(function (btn) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      id: btn.id,
      key: btn.id,
      priority: btn.buttonPriority,
      type: btn.buttonType,
      size: "medium",
      label: btn.text,
      onClick: btn.onClick,
      className: classes.rightButtons,
      disabled: btn.disabled
    });
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: saveID || 'saveBottomBar',
    size: "medium",
    label: saveButtonText,
    onClick: onSave,
    className: classes.button,
    disabled: saveDisabled
  })));
}